export default 'featureFlags'
